var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgCheckeredFlag(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M12.001 8h2.667V5.334h-2.667zm5.334 0V5.334H20V8zM12 18.667V16h2.667v2.667zm10.667-5.334v-2.666h2.667v2.667zm0 5.334V16h2.667v2.667zm-5.333 0V16H20v2.667zM22.668 8V5.334h2.667V8zm-8 2.667V8h2.667v2.667zm-6.667 16a1.3 1.3 0 01-.95-.384 1.3 1.3 0 01-.383-.95V6.668q0-.567.383-.95a1.3 1.3 0 01.95-.383q.567 0 .95.383.384.383.384.95V8H12v2.667H9.335v2.667H12V16H9.335v9.334q0 .566-.384.95a1.3 1.3 0 01-.95.383m12-10.667v-2.666h2.667V16zm-5.333 0v-2.666h2.667V16zm-2.667-2.666v-2.667h2.667v2.667zm5.334 0v-2.667H20v2.667zM20 10.667V8h2.667v2.667z"
  })));
}
export default SvgCheckeredFlag;